/* eslint-disable camelcase */

import { DataFieldType, ProcessorFieldType, RenderingStatus } from './enums'

export interface ProcessorField {
  id: string | number
  displayName: string
  fieldName: string
  portalId: number
  data_type: ProcessorFieldType
}

export enum TemplateType {
  responseTemplate = 'response_template',
  stylesheet = 'stylesheet',
  configurationPanel = 'configuration_panel'
}

export interface RenderingGeneralData {
  id: number
  templateId: number
  displayName: string
  templateName: string
  templateType: TemplateType
  childTemplateIds: number[]
  parentTemplateIds: number[]
  status: RenderingStatus
  dirty: boolean
  finalized: boolean
  includeInResponse: boolean
  processorField: ProcessorField
}

export interface RenderingContent {
  templateId: number
  content: string
  templateWorkflowDescription: string
}

export interface JSONSchema {
  items: {
    properties: { [key: string]: { name: string; type: string[] } }
    required?: string[]
  }[]
}

export interface DataField {
  id: number
  name: string
  dataType: DataFieldType
  jsonSchema: JSONSchema
  required: true
  datasetPath: string
  templateId: number
  merchant_evidence_id?: number
}

export interface RenderingDTO extends RenderingGeneralData {
  dataFields: DataField[]
}

export interface ExtendedRendering extends RenderingDTO {
  filteredParentTemplateIds?: number[]
  filteredChildTemplateIds?: number[]
}

export interface DatasetDTO {
  [key: string]: any
}

export interface ImageLibraryData {
  id?: number | string
  path: string
  template_id: number | string
  evidence_id: number | string
}

export interface ImageDTO {
  caption?: string
  group?: string
  id?: number
  name?: string
  src?: string | ArrayBuffer
  image?: File
  templateId?: number
  type?: DataFieldType
  fallback_to_library?: boolean
  merchant_library_version?: number
  imageLibraryData: ImageLibraryData
}

export interface DisputeDTO {
  notes: string
  lifecycleStatus: LifecycleStatus
  lifecycleStatusActions: LifecycleStatusActions[]
  tags: TagsDTO
  assignee: UserDTO
  locked: boolean
  expired: boolean
  disposition: Disposition
  manualDelivery: boolean
  expirationDate: string
  requestDate: string
  mid: MidDTO
  merchant: MerchantDTO
  stage: string
  remoteInvoiceId: string
  remoteTransactionId: string
  portal: { id: number; name: string }
  reasonCodeCategory: string
  sentOn: string
  deliveredOn: string
  lifecycleTransitioningTo: LifecycleStatus
  automatedAcceptLiability: boolean
}

export interface BuyerIdentityDTO {
  totalDisputesNumber: number
  totalDisputesAmount: number
  totalWonDisputes: number
  totalLostDisputes: number
  transactionData: {
    transactionCount: number
    totalAmountsByCurrency: {
      [currency: string]: number
    }
  }
  orderData: {
    orderCount: number
    totalAmountsByCurrency: {
      [currency: string]: number
    }
  }
  currencyCode: string
  reasonCodes: {
    fraud?: number
    processingError?: number
  }
}

export type TagsDTO = Array<TagDTO>

export interface TagDTO {
  id: number
  name: string
}

export interface UserDTO {
  id: number
  name: string
}
export interface MidDTO {
  id: number
  name: string
}
export interface MerchantDTO {
  id: number
  name: string
}

export interface ResponsePreviewDTO extends RenderingContent {
  responseContent: string
  renderingPdfUrl: string
  templateDisplayName: string
}

export interface ProcessorRequirementsDTO {
  [processorName: string]: {
    message: string[]
  }
}

export interface LifecycleStatusActions {
  name: LifecycleAction
  description: string
}

export enum LifecycleStatus {
  new = 'new',
  urgent = 'urgent',
  documentSent = 'document_sent',
  docsendFailed = 'docsend_failed',
  acceptLiability = 'accept_liability',
  queuedToSend = 'queued_to_send',
  readyToSend = 'ready_to_send',
  readyToAccept = 'ready_to_accept',
  queuedToAccept = 'queued_to_accept'
}

export enum Disposition {
  won = 'won',
  lost = 'lost',
  pending = 'pending'
}

export enum LifecycleAction {
  ready_to_send = 'ready_to_send',
  queue_to_send = 'queue_to_send',
  send_complete = 'send_complete',
  reset_lifecycle = 'reset_lifecycle',
  ready_to_accept = 'ready_to_accept',
  queue_to_accept = 'queue_to_accept',
  accept_complete = 'accept_complete',
  system_complete = 'system_complete'
}
